import L from 'leaflet';

type TCoordinates = { lat: number, lng: number };

const mapJsClass = 'js-map';

const mapElements = document.querySelectorAll('.' + mapJsClass) as NodeListOf<HTMLElement>;

mapElements.forEach((mapElement) => {
    // We get the coordinates form the data attribute
    const coordinates: TCoordinates = mapElement.dataset.coordinates && JSON.parse(mapElement.dataset.coordinates);

    // We get the marker icon from the data attribute
    const markerUrl = mapElement.dataset.markerUrl;

    if (!coordinates && !markerUrl) {
        return;
    }

    // We create a latLng using the coordinates
    const latLng = L.latLng(coordinates.lat, coordinates.lng);

    // We create the map
    const map = L.map(mapElement, {
        center: latLng,
        zoom: 13,
        zoomControl: false
    });

    // We give the map a tileLayer
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: 20
    }).addTo(map);

    L.control.zoom({
        zoomInTitle: 'Zoomer',
        zoomOutTitle: 'Dézoomer'
    }).addTo(map);

    // We create a custom marker icon
    const markerIcon = L.icon({
        iconUrl: markerUrl,
        iconSize: [25, 41],
        iconAnchor: [12.5, 41]
    });

    // We create the marker and add it to the map
    L.marker(latLng, { icon: markerIcon }).addTo(map);
});